import React, { useState } from 'react'

import SvgAngleRight from '@Assets/SVG/AngleRight'
import { LoadingSpinner } from '@Components/Loading'
import { SizeDrawer } from '@Domains/Cart/Components/Prompt/Size'
import { Product, useProductForSizePromptLazyQuery } from '@Generated/graphql'
import { useLocale } from '@Globals/Locale'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './BuyButtonArea.module.scss'

export const ChooseSizeSelect = ({
  product,
  selectedVariantID,
  setSelectedVariantID,
}: {
  product: Product
  selectedVariantID: string
  setSelectedVariantID: (variantID: string) => void
}) => {
  const { t } = useTranslation()
  const locale = useLocale()
  const isVariantB = useSplitTest('select_size_v1', 'b')
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [loadSizePromptProduct, { data, loading }] = useProductForSizePromptLazyQuery({
    variables: { id: product.id },
  })

  if (!isVariantB) {
    return null
  }

  const sizePromptProduct = data?.product
  const selectedVariant = sizePromptProduct?.variants?.find(variant => variant.id === selectedVariantID)
  // @ts-ignore
  const sizeLabel = selectedVariant?.size?.value?.label?.[locale] || selectedVariant?.size?.value?.key

  const openDrawer = () => {
    setDrawerOpen(true)
    loadSizePromptProduct()
  }

  return (
    <div className={styles.chooseSizeWrap}>
      <button
        aria-busy={loading}
        className={styles.chooseSizeButton}
        onClick={openDrawer}
        type="button"
      >
        <span>
          {sizeLabel || t('products:CHOOSE_SIZE')}
        </span>
        {loading ? <LoadingSpinner className={styles.chooseSizeSpinner} /> : <SvgAngleRight className={styles.icon} />}
      </button>

      {drawerOpen && sizePromptProduct && (
        <SizeDrawer
          initialVariantID={selectedVariantID}
          loading={false}
          onOpenChange={(open) => {
            if (!open) {
              setDrawerOpen(false)
            }
          }}
          onSubmit={(variantID) => {
            setSelectedVariantID(variantID)
            setDrawerOpen(false)
          }}
          open
          product={sizePromptProduct}
          promptTrigger="choose_size"
          submitOnSelect
        />
      )}
    </div>
  )
}
